import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { SyncRunRecordsResponse } from "../model/SyncRunRecord";
import { GetSyncRunRecordsRequest } from "../request/GetSyncRunRecordsRequest";

const GetSyncRunRecordsApiService = async (
  request: GetSyncRunRecordsRequest
): Promise<SyncRunRecordsResponse> => {
  const { data } = await axios.get<SyncRunRecordsResponse>(
    "integrations/block-events/",
    { params: request }
  );
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useGetSyncRunRecordsApiService = (
  request: GetSyncRunRecordsRequest,
  enabled: boolean
) =>
  useQuery<SyncRunRecordsResponse, AxiosError>(
    ["GetSyncRunRecordsApiService", ...Object.values(request)],
    () => GetSyncRunRecordsApiService(request),
    { keepPreviousData: true, enabled }
  );
